

// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ****************************** Import CSS ******************************** //

import "./book.css";

// ****************************** Import Images ******************************** //

import "/src/assets/book/heartheads-cover.jpg"
import "/src/assets/book/heartheads-cover-on-book.png"

// **************************** Add Top Nav & Footer ************************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// **************************** Flyer Popup Modal ************************** //



// ************ Add Email Signup *************** //